import { makeStateKey } from "@angular/platform-browser";

export const CSP_NONCE_KEY = makeStateKey<string>('CSP_NONCE_KEY');